import { SHOT_MARKS } from "../util/reportColors";

/**
 * The make / miss chart's key, one caption on both views (Trevor, 2026-10-10): "● make 23 · × miss 37 · halfcourt
 * shots", drawn in the chart's own marks (util/reportColors SHOT_MARKS). Sized by the caption it sits in.
 */
export default function ShotMarksKey({ shots }: { shots: { made: boolean }[] }) {
  const makes = shots.filter((s) => s.made).length;
  return (
    <span className="ShotMarksKey">
      <span
        style={{
          display: "inline-block",
          width: 8,
          height: 8,
          borderRadius: "50%",
          verticalAlign: -1,
          background: SHOT_MARKS.make,
        }}
      />{" "}
      make {makes} ·{" "}
      <span style={{ fontWeight: 700, fontSize: 12, lineHeight: 1, color: SHOT_MARKS.miss }}>×</span> miss{" "}
      {shots.length - makes} · halfcourt shots
    </span>
  );
}
